import React, { useState } from "react";
import { Button } from "../../components/ui/button";
import { Card, CardContent } from "../../components/ui/card";
import {
  Page,
  PageHeader,
  StatusBadge,
  Timeline,
  TimelineItem,
} from "../../components/patterns";
import type { TimelineStatus } from "../../components/patterns";

// Placeholder milestones until project journeys are served by the API.
const INITIAL_MILESTONES = [
  {
    title: "Setup Profile",
    description: "Details of yourself and/or others.",
    completed: false,
  },
  {
    title: "New Home",
    description: "Application accepted and transitioned.",
    completed: false,
  },
  {
    title: "Properties Review",
    description: "Viewings booked and reviewed.",
    completed: false,
  },
  {
    title: "Book Meeting",
    description: "Discuss the property list with your agent.",
    completed: false,
  },
  {
    title: "Follow Up",
    description: "Double check open items.",
    completed: false,
  },
];

const userRole = "agent";

const ProjectJourney = () => {
  const [milestones, setMilestones] = useState(INITIAL_MILESTONES);

  const completeStep = (index: number) => {
    if (userRole !== "agent") return;
    setMilestones((previous) =>
      previous.map((item, itemIndex) =>
        itemIndex === index ? { ...item, completed: true } : item,
      ),
    );
  };

  const completedCount = milestones.filter((item) => item.completed).length;
  // The first milestone that is not finished is the one in progress.
  const currentIndex = milestones.findIndex((item) => !item.completed);

  const statusFor = (index: number): TimelineStatus => {
    if (milestones[index].completed) return "complete";
    return index === currentIndex ? "current" : "upcoming";
  };

  return (
    <Page width="narrow">
      <PageHeader
        title="Project journey"
        description="Relocation milestones and current progress."
        meta={
          <StatusBadge tone={completedCount === milestones.length ? "success" : "info"}>
            {completedCount} of {milestones.length} complete
          </StatusBadge>
        }
      />

      <Card>
        <CardContent className="pt-5">
          <Timeline label="Relocation milestones">
            {milestones.map((item, index) => (
              <TimelineItem
                key={item.title}
                title={item.title}
                description={item.description}
                status={statusFor(index)}
                last={index === milestones.length - 1}
                action={
                  userRole === "agent" && !item.completed ? (
                    <Button
                      type="button"
                      variant="outline"
                      size="sm"
                      onClick={() => completeStep(index)}
                    >
                      Mark complete
                      <span className="sr-only">{`: ${item.title}`}</span>
                    </Button>
                  ) : undefined
                }
              />
            ))}
          </Timeline>
        </CardContent>
      </Card>
    </Page>
  );
};

export default ProjectJourney;
